import { createHOC } from 'vue-hoc';

import OrgSelector from './OrgSelector';
import auth, { groupsDataKey } from '../../providers/auth';
import userManagement from '../../providers/userManagement';
import withSubscriptionState from '../../hoc/withSubscriptionState';
import withUser from '../../hoc/withUser';

const options = {
  name: 'OrgSelectorContainer',
  data() {
    const groupsData = JSON.parse(localStorage.getItem(groupsDataKey));
    const orgGroups = groupsData.filter((group) => !group.metadata.parent);
    return {
      state: {
        loading: false,
        error: null,
        orgGroups,
      },
    };
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.replace({ name: 'login' });
      return;
    }
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
    orgGroups() {
      return this.state.orgGroups;
    },
  },
  listeners: {
    async changeActiveOrg(orgId) {
      this.state.error = null;
      try {
        this.state.loading = true;
        await userManagement.post('/auth/changeOrg', {
          orgId,
        });
        await auth.renewSession();
        this.$emit('orgChange', orgId);
      } catch (e) {
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const OrgSelectorContainer = createHOC(
  withUser()(withSubscriptionState()(OrgSelector)),
  options,
  renderWith
);
export default OrgSelectorContainer;
